import { CheckboxMultiple } from 'mixs/inputs/checkbox-multiple';
export class ComplexDeliveryAttachments extends CheckboxMultiple {
  public onChangeCheckbox(e){
    this.onChange(e);
  }
  public onChangeHowToSend(namespace){
    return (e) => {
      let items = {};
      items[namespace] = { how_to_send: { value: e.target.value } }
      this.dispatch({ items: items, updated_at: new Date().getTime() })
    }
  }
  public onChangeDeliveryPattern(namespace){
    return (e) => {
      let items = {};
      items[namespace] = { delivery_pattern: { value: e.target.value } }
      this.dispatch({ items: items, updated_at: new Date().getTime() })
    }
  }
  public onChangeBillsPattern(namespace){
    return (e) => {
      let items = {};
      items[namespace] = { bills_pattern: { value: e.target.value } }
      this.dispatch({ items: items, updated_at: new Date().getTime() })
    }
  }
  public onChangeMemoForInspection(namespace){
    return (e) => {
      let items = {};
      items[namespace] = { memo_for_inspection: { value: e.target.value } }
      this.dispatch({ items: items, updated_at: new Date().getTime() })
    }
  }
  public onChangeSendTo(namespace){
    return (e) => {
      let items = {};
      items[namespace] = { send_to: { value: e.target.value } }
      this.dispatch({ items: items, updated_at: new Date().getTime() })
    }
  }
}
riot.mixin('inputs.complex.delivery-attachments', ComplexDeliveryAttachments as riot.TagMixin)
